<template>
    <div class="StatusEditor">
        <!--DISPLAY TABLE-->
        <b-container fluid>
            <b-row style="overflow-x:auto;">
                <b-col cols="11">
                    <vuetable :fields="TableFields"
                              :data="TableData"
                              pagination-path=""
                              :api-mode="false"
                              class="vue-datatable"
                              row-class="bold-first-row">

                        <template slot="DetailView" scope="props">
                            <div class="DetailView">
                                <span class="underline pointer" @click="ShowDetailView(props.rowData)"><span v-html="props.rowData.Name"></span> <font-awesome-icon :icon="['fa', 'edit']" v-if="EditMode" /></span>
                            </div>
                        </template>
                    </vuetable>
                </b-col>
                <b-col cols="1">
                    <div v-if="EditMode" class="vert-icons">
                        <b-row>
                            <font-awesome-icon :icon="['fa', 'plus']" v-on:click="ShowAddEditSchool()" class="pointer olive-green-text" />
                        </b-row>
                    </div>
                </b-col>
            </b-row>
        </b-container>

        <!--ADD AND EDIT AND DETAIL MODAL-->
        <b-modal ref="modal-school" size="lg" :title="ModalSchoolTitle" hide-footer no-close-on-esc no-close-on-backdrop>
            <b-container v-if="EditMode == false && TargetSchool.Id">
                <b-row>
                    <b-col>
                        <h3>Status Info</h3>
                        <p><span class="bold">Name: </span>{{TargetSchool.Name}}</p>
                        <p><span class="bold">Specifier: </span>{{TargetSchool.Specifier}}</p>
                    </b-col>
                    <b-col>
                        <h3>Details:</h3>
                        <p><span class="bold">Notes: </span>{{TargetSchool.Comments}}</p>
                        <p><span class="bold">Effective Date: </span>{{ formatDate(TargetSchool.StartDate,'MM/DD/YY') }}</p>
                    </b-col>
                </b-row>
                <b-row class="modal-btn-row">
                    <div class="modal-btn-row-div">
                        <b-button size="md" variant="secondary" @click="CancelSchool()">
                            CLOSE
                        </b-button>
                    </div>
                </b-row>
            </b-container>
            <b-container v-if="EditMode">
                <b-form @submit="AddEditSchool" autocomplete="off">
                    <b-row>
                        <b-col>
                            <h3>Status Info</h3>
                            <div class="form-group">
                                <label>Status Name:</label>
                                <select type="text" required class="form-control" v-model="TargetSchool.Name" :disabled="TargetSchool.Id">
                                    <option value="Prospect">Prospect</option>
                                    <option value="Informed">Informed</option>
                                    <option value="Active">Active</option>
                                    <option value="Engaged">Engaged</option>
                                    <option value="Equipped">Equipped</option>
                                    <option value="Inactive">Inactive</option>
                                </select>
                            </div>
                        </b-col>
                        <b-col>
                            <h3>Details</h3>
                            <div class="form-group">
                                <label>Comments::</label>
                                <textarea v-model="TargetSchool.Comments" class="form-control" rows="4"></textarea>
                            </div>
                            <div class="form-group">
                                <label>Effective Date:</label>
                                <flat-pickr v-model="TargetSchool.StartDate" class="form-control" required :config="DateConfig"></flat-pickr>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row class="modal-btn-row">
                        <div class="modal-btn-row-div">
                            <b-button size="md" variant="secondary" @click="CancelSchool()">
                                CANCEL
                            </b-button>
                            <b-button size="md" variant="success" type="submit" v-if="EditMode">
                                SAVE
                            </b-button>
                            <b-button size="md" variant="danger" @click="DeleteSchool()" type="button" v-if="TargetSchool.Id">
                                DELETE
                            </b-button>
                        </div>
                </b-form>
            </b-container>
        </b-modal>
    </div>

</template>

<script>
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faEdit } from '@fortawesome/free-solid-svg-icons';
    library.add(faEdit);
    import { faPlus } from '@fortawesome/free-solid-svg-icons';
    library.add(faPlus);
    import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faTrashAlt);
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';

    import Vuetable from 'vuetable-2/src/components/Vuetable';

    export default {
        props: [
            "EditMode",//bool
            "GlobalUpdate",//bool
            "ChartId"
        ],
        data: function () {
            return {
                TargetSchool: {},
                CommonSchoolSelection: "",
                ModalSchoolTitle: "",
                LoadedRecords: [],//Contact Membership Records
                SchoolSchema: {
                    StartDate: "",
                    Name: "",
                    Specifier: "",
                    Comments: "",
                    ChurchID: ""
                },
                DateConfig: {
                    dateFormat: 'Y-m-d',
                    allowInput: true,
                    altInput: true,
                    altFormat: 'm/d/Y',
                    required: false
                }

            };
        },
        methods: {
            onRowClass(dataItem, index) {
                return (dataItem.EndDate == null) ? 'current-record' : '';
            },
            GetSchools() {
                this.$MasterAPI.ExecuteRequest("GET", "StrongFamilies/Churches/Status/GetStatuses", { ChurchID: this.ChartId }, this.GetSchoolsSuccess, () => { }, false);
            },
            GetSchoolsSuccess(response) {
                this.LoadedRecords = response.data.data;
            },
            ShowDetailView(school) {
                this.TargetSchool = JSON.parse(JSON.stringify(school));

                if (this.EditMode) {
                    this.ModalSchoolTitle = "Editing Status ";
                } else {
                    this.ModalSchoolTitle = "Viewing Status";
                }
                this.$refs["modal-school"].show();
            },
            ShowAddEditSchool() {
                this.TargetSchool = JSON.parse(JSON.stringify(this.SchoolSchema));
                this.ModalSchoolTitle = "Add New Status";
                this.$refs["modal-school"].show();
            },
            AddEditSchool(e) {
                e.preventDefault();
                this.TargetSchool.ChurchID = this.ChartId;
                this.$MasterAPI.ExecuteRequest("POST", "StrongFamilies/Churches/Status/AddEditStatus", this.TargetSchool, this.AddEditSchoolSuccess, () => { }, true);
            },
            AddEditSchoolSuccess(reponse) {
                this.GetSchools();
                this.$GlobalUpdate.ExecuteGlobalUpdate(this.ChartId);
                this.$refs["modal-school"].hide();
            },
            DeleteSchool() {
                this.$MasterAPI.ExecuteRequest("POST", "StrongFamilies/Churches/Status/DeleteStatus", { Id: this.TargetSchool.Id }, this.DeleteSchoolSuccess, () => { }, true);
            },
            DeleteSchoolSuccess(response) {
                this.GetSchools();
                this.$refs["modal-school"].hide();
            },
            CancelSchool() {
                this.$refs['modal-school'].hide();
            },
            formatDate(value, fmt = 'D MMM YYYY') {
                return (value == null || value == '')
                    ? ''
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            }
        },
        components: {
            flatPickr,
            Vuetable
        },
        computed: {
            TableFields: function () {
                let vm = this;
                let fieldData = [
                    {
                        name: "__slot:DetailView",
                        title: "NAME"
                    },
                    {
                        name: "Specifier",
                        title: "SPECIFIER"
                    },
                    {
                        name: "Comments",
                        title: "COMMENTS"
                    },
                    {
                        name: "StartDate",
                        title: "DATE",
                        callback: 'formatDate|MM/DD/YY',
                    }
                ];
                return fieldData;
            },
            TableData: function () {
                return this.LoadedRecords;
            }
        },
        mounted() {
            this.GetSchools();
            this.TargetSchool = this.SchoolSchema;
        }
    }
</script>

<style scoped>
    .vert-icons div {
        margin-top: 10px;
    }

    /deep/ tbody tr:first-child {
        font-weight: bold;
    }

    table {
        table-layout: auto;
    }

    .vue-datatable {
        width: 100%;
        display: inline-table;
        overflow-x: auto;
    }
</style>